import { LitElement, html, nothing } from 'lit';
import '@cof/fs-alert-wc/fs-alert.js';
import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import { TagKey } from '@cof/tag-catalog-refi-user-entry-mfe';
import { DebugService } from '../../../services/debug/debug.service.js';
import { stratum } from '../../../constants/stratum.js';
import { CustomerOffer } from '../../../models/search-customer-offers.model.js';

class RefiOfferBanner extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiOfferBanner');
    this.message = '';
    this.offer = {};
  }

  static properties = {
    message: { type: String, reflect: true },
    offer: { type: Object, reflect: true },
  };

  connectedCallback() {
    super.connectedCallback();
    this.debug.log('loaded with', this.offer);
    this.message = this.getMessage();
    if (this.message.length > 0) {
      trackAnalyticsEvent('access code banner display', '', 'display', 'banner');
      stratum.publishTag(TagKey.ACCESS_CODE_ACCESS_CODE_BANNER_DISPLAY);
    }
  }

  render() {
    return html`
      ${this.message.length > 0
        ? html`<div id="offer-match-banner">
            <fs-alert type="success">${this.message}</fs-alert>
          </div>`
        : nothing}
    `;
  }

  getMessage() {
    if (this.offer && CustomerOffer.isValid(this.offer)) {
      switch (this.offer.offerType) {
        case 'GUARANTEED_RATE':
          return `We’ll guarantee you a personalized APR of ${this.offer.annualPercentRate.toFixed(2)}% if you’re approved.`;
        case 'PRE_APPROVAL':
          return `It's a match! You've been offered a personalized APR of ${this.offer.annualPercentRate.toFixed(2)}%.`;
        default:
          return '';
      }
    }
    return '';
  }
}

customElements.define('refi-offer-banner', RefiOfferBanner);
